export const validateNewPassword = (value: string) => {
    const pwRegex = new RegExp(/(?!.*[cC][sS][wW]).*(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{8}/)
    const message = 'La password deve essere lunga almeno 8 caratteri, deve contenere almeno una lettera minuscola'
        + ', una maiuscola ed un numero, e non può contenere la parola "csw".'
    return pwRegex.test(value) || message;
}
